import styled from "@emotion/styled";
import React, { type PropsWithChildren } from "react";

export type VisuallyHiddenProps = PropsWithChildren & {
  htmlFor?: string;
  tagName?: keyof HTMLElementTagNameMap;
  id?: string;
};

export const VisuallyHidden = ({
  tagName,
  htmlFor,
  id,
  children,
}: VisuallyHiddenProps) => {
  const Tag = tagName || "span";

  const Hidden = styled(Tag)`
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0 0 0 0);
    white-space: nowrap;
    border: 0;
  `;

  return (
    <Hidden htmlFor={htmlFor} id={id}>
      {children}
    </Hidden>
  );
};
